import React from 'react';
import { Skeleton } from '@mantine/core';

import { When } from '../common';

type Props = {
    showChart?: boolean;
};

export function ProductSalesChartSkeleton({ showChart = true }: Props) {
    return (
        <div
            className="flex flex-col gap-4"
            role="status"
            aria-live="polite"
            aria-busy
            aria-label="Loading product sales"
        >
            <div className="flex w-full overflow-hidden rounded-lg border border-[#EDEFF2] bg-[#FAFBFC]">
                <div className="flex min-w-0 flex-1 flex-col gap-2 px-4 py-3">
                    <Skeleton height={12} width={72} radius="sm" />
                    <Skeleton height={18} width={110} radius="sm" />
                    <Skeleton height={14} width={90} radius="sm" />
                </div>
                <div className="my-2 w-px shrink-0 bg-[#e6e9ef]" />
                <div className="flex min-w-0 flex-1 flex-col gap-2 px-4 py-3">
                    <Skeleton height={12} width={72} radius="sm" />
                    <Skeleton height={18} width={110} radius="sm" />
                    <Skeleton height={14} width={90} radius="sm" />
                </div>
                <div className="my-2 w-px shrink-0 bg-[#e6e9ef]" />
                <div className="flex min-w-0 flex-1 flex-col gap-2 px-4 py-3">
                    <Skeleton height={12} width={80} radius="sm" />
                    <Skeleton height={18} width={100} radius="sm" />
                    <Skeleton height={14} width={96} radius="sm" />
                </div>
            </div>

            <When condition={showChart}>
                <div className="flex flex-wrap items-center justify-between gap-3">
                    <div className="flex items-center gap-4">
                        <Skeleton height={14} width={120} radius="sm" />
                        <Skeleton height={14} width={120} radius="sm" />
                    </div>
                    <div className="flex items-center gap-2">
                        <Skeleton height={28} width={140} radius="md" />
                        <Skeleton height={28} width={160} radius="md" />
                    </div>
                </div>

                <Skeleton height={224} radius="md" className="w-full" />
            </When>
        </div>
    );
}

export default ProductSalesChartSkeleton;
